import { Flex } from 'antd';
import { BaseButton } from 'components/button/button-base';
import { BaseHeader } from 'components/header';
import { Text, Title } from 'components/mvp-typography';
import { PrintableRootPage } from 'components/page/page-2';
import { useAppSelector } from 'lib/store/rootReducer';
import { Link, useLocation } from 'react-router-dom';
import { IntegrationRoutes } from 'routes';
import { useIsInPilot } from './_components/pilot-content';

type Args = { signedIn: boolean; isInPilot: boolean };
const BUTTON_MAP: {
  text: string;
  link: string;
  condition: (args: Args) => boolean;
}[] = [
  {
    text: 'Continue to ConcussionRx',
    link: IntegrationRoutes.IMPACT_PATIENT_IMPORT,
    condition: _ => _.isInPilot
  },
  {
    text: 'Join the ImPACT Pilot',
    link: IntegrationRoutes.IMPACT_LANDING_SIGNIN,
    condition: _ => _.signedIn
  },
  {
    text: 'Sign In',
    link: IntegrationRoutes.IMPACT_LANDING_SIGNIN,
    condition: () => true
  }
];

function resolveButtonContent(args: Args) {
  const mapping = BUTTON_MAP.find(_ => _.condition?.(args));
  if (mapping === undefined) {
    throw new Error(
      `[resolveButtonContent] No mapping was found for the arguments: ${JSON.stringify(
        args
      )}`
    );
  }
  return mapping;
}

export function PageIntegrationLandingPage() {
  const user = useAppSelector(state => state.auth.user);
  const pilotQuery = useIsInPilot(user?.uid ?? '');
  const location = useLocation();
  const isInPilot = pilotQuery.data?.isInPilot ?? false;
  const buttonContent = resolveButtonContent({
    signedIn: !!user,
    isInPilot: isInPilot
  });
  return (
    <>
      <BaseHeader
        headerStyle={{
          background: 'none'
        }}
      />
      <PrintableRootPage title="">
        <Title>ImPACT Landing Page</Title>
        <Text>
          This page explains:
          <ul>
            <li>What is ConcussionRx?</li>
            <li>What can ConcussionRx do for me?</li>
            <li>What is the nature of the pilot?</li>
            <li>What information will be shared?</li>
            <li>How will information be protected?</li>
            <li>Can I opt-out later if I do not like the service?</li>
          </ul>
        </Text>
        <Flex gap={16}>
          <Link
            to={{
              pathname: buttonContent.link,
              search: location.search
            }}
          >
            <BaseButton>{buttonContent.text}</BaseButton>
          </Link>
        </Flex>
      </PrintableRootPage>
    </>
  );
}
